import React from 'react';
import Container from './Container';

export default ({ location }) => (
  <Container>
    <iframe src={location.embedded_map} width="100%" height="350" />
  </Container>
);
